import axios from 'axios';
if (!import.meta.env.VITE_APP_ABMI_API_BASE_URL) {
  throw new Error('ABMI API Env not set: VUE_APP_ABMI_API_BASE_URL');
}

const abmiApiUrl = import.meta.env.VITE_APP_ABMI_API_BASE_URL;

const abmiAxios = axios.create({
  baseURL: abmiApiUrl + 'bio-browser-chart'
});

export async function getSpeciesHabitatGraph(tsn, year, isSpecies) {
  const apiFct = '/get-species-abundance-data';
  try {
    const response = await abmiAxios.get(apiFct, { params: { tsn, year, isSpecies } });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}
export async function getSpeciesHabitatFewDetectionGraph (tsn, year, isNorth, isSpecies, isNewOrder) {
  const apiFct = '/get-few-detection-data';
  try {
    const response = await abmiAxios.get(apiFct, { params: { tsn, year, isNorth, isSpecies, isNewOrder } });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}
export async function getTreeNonTreeSiteData (tsn, year, isSpecies) {
  const apiFct = '/get-tree-non-tree-site-data';
  try {
    const response = await abmiAxios.get(apiFct, { params: { tsn, year, isSpecies } });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

export async function getLinearData (tsn, year, isSpecies) {
  const apiFct = '/get-linear-data';
  try {
    const response = await abmiAxios.get(apiFct, { params: { tsn, year, isSpecies } });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}
export async function getSectorData (tsn, year, isNorth, isSpecies) {
  const apiFct = '/get-sector-data';
  try {
    const response = await abmiAxios.get(apiFct, { params: { tsn, year, isNorth, isSpecies } });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

export async function getOSRSectorDensityData (tsn, year) {
  const apiFct = '/get-osr-sector-density-data';
  try {
    const response = await abmiAxios.get(apiFct, { params: { tsn, year } });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

export async function getOSROnOffHFData (tsn, year) {
  const apiFct = '/get-on-vs-off?';
  try {
    const response = await abmiAxios.get(apiFct, { params: { tsn, year } });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

export async function getOSREdgeDistsanceData (tsn, year) {
  const apiFct = '/get-osr-edge-distance';
  try {
    const response = await abmiAxios.get(apiFct, { params: { tsn, year } });
    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

const abmiApi = {
  getLinearData,
  getTreeNonTreeSiteData,
  getSpeciesHabitatGraph,
  getSpeciesHabitatFewDetectionGraph,
  getSectorData
};

export default abmiApi;
